export const ZOHO_HARDWARE_QUOTE_FORM_ACTION =
  "https://forms.zohopublic.com/pickcel/form/HardwareGetaQuote/formperma/QXW6Xg1rCZmMH3LU9LEGQlQcGtDgyUGfNIb-_aV1lWc/htmlRecords/submit";

export const ZOHO_HARDWARE_QUOTE_IFRAME_TARGET = "hardware-quote-zoho-target";

export const COMPANY_SIZE_OPTIONS = [
  { value: "1–50", label: "1–50" },
  { value: "51–250", label: "51–250" },
  { value: "251–1,000", label: "251–1,000" },
  { value: "1,000+", label: "1,000+" },
] as const;

export const LOCATION_OPTIONS = [
  { value: "1 site", label: "1 site" },
  { value: "2–10 sites", label: "2–10 sites" },
  { value: "11–50 sites", label: "11–50 sites" },
  { value: "50+ sites", label: "50+ sites" },
] as const;

export const SCREEN_OPTIONS = [
  { value: "1–10 screens", label: "1–10 screens" },
  { value: "11–50 screens", label: "11–50 screens" },
  { value: "51–200 screens", label: "51–200 screens" },
  { value: "200+ screens", label: "200+ screens" },
  { value: "Not sure yet", label: "Not sure yet" },
] as const;

export const PRIMARY_NEED_OPTIONS = [
  { value: "New rollout", label: "New rollout" },
  { value: "Hardware refresh", label: "Hardware refresh" },
  { value: "Installation only", label: "Installation only" },
] as const;
